import type { Movie, GenreInfo } from "@/types/movie";

export const genres: GenreInfo[] = [
  {
    name: "动作",
    slug: "动作",
    icon: "ri-sword-line",
    description: "高能打斗、紧张追逐与硬核爆炸场面，肾上腺素全程拉满",
  },
  {
    name: "爱情",
    slug: "爱情",
    icon: "ri-heart-3-line",
    description: "怦然心动的相遇与细腻动人情感，治愈每一段孤独时光",
  },
  {
    name: "科幻",
    slug: "科幻",
    icon: "ri-planet-line",
    description: "穿越星际与未来想象，探索科技与人性的无限边界",
  },
  {
    name: "喜剧",
    slug: "喜剧",
    icon: "ri-emotion-happy-line",
    description: "轻松爆笑的欢乐合集，一次看个够，解压首选",
  },
  {
    name: "悬疑",
    slug: "悬疑",
    icon: "ri-question-line",
    description: "层层反转与烧脑线索，不到最后一秒猜不到真相",
  },
  {
    name: "恐怖",
    slug: "恐怖",
    icon: "ri-ghost-line",
    description: "暗夜惊魂与心跳加速的恐惧体验，胆大者请入",
  },
  {
    name: "动画",
    slug: "动画",
    icon: "ri-magic-line",
    description: "天马行空的画风与温暖故事，全年龄都爱看",
  },
  {
    name: "剧情",
    slug: "剧情",
    icon: "ri-book-open-line",
    description: "贴近生活的深刻叙事，细腻描绘人性与命运",
  },
  {
    name: "战争",
    slug: "战争",
    icon: "ri-shield-star-line",
    description: "宏大战场与家国情怀，还原历史中的热血与悲壮",
  },
  {
    name: "犯罪",
    slug: "犯罪",
    icon: "ri-fingerprint-line",
    description: "警匪较量与灰色地带，揭开罪案背后的真相",
  },
];

export const regions: string[] = ["大陆", "美国", "香港", "韩国", "日本", "英国", "法国"];

export const years: number[] = [2024, 2023, 2022, 2021, 2020];

export const movies: Movie[] = [
  {
    id: "xinghai-guhang",
    title: "星海孤航",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20planet%2C%20deep%20navy%20space%20with%20warm%20amber%20rim%20light%2C%20minimal%20clean%20background%2C%20dramatic%20atmospheric%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-01&orientation=portrait",
    year: 2024,
    genres: ["科幻", "冒险"],
    region: "美国",
    language: "英语",
    duration: 138,
    director: "克里斯·诺兰",
    cast: ["李维·陈", "艾玛·斯通", "张远"],
    rating: 9.2,
    views: 12860000,
    heat: 9860,
    updatedAt: "2024-09-28",
    tagline: "当宇宙只剩下一个人的心跳",
    synopsis:
      "一支深空探测队在距地球四光年的星域失联，唯一的幸存者必须在氧气耗尽前找到返航坐标。孤独、记忆与求生的本能，在无垠星海中交织成一场关于人类意志的悲壮航行。",
  },
  {
    id: "anye-zhuixiong",
    title: "暗夜追凶",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%2C%20silhouette%20of%20a%20detective%20under%20rainy%20neon%20night%20city%2C%20deep%20blue%20tones%20with%20orange%20street%20lights%2C%20minimal%20clean%20background%2C%20moody%20dramatic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-02&orientation=portrait",
    year: 2024,
    genres: ["动作", "犯罪", "悬疑"],
    region: "香港",
    language: "粤语",
    duration: 124,
    director: "陈木森",
    cast: ["古天乐", "林家栋", "文咏珊"],
    rating: 8.7,
    views: 9860000,
    heat: 9320,
    updatedAt: "2024-09-25",
    tagline: "每一条线索都指向更深的黑暗",
    synopsis:
      "连环凶案让整座城市陷入恐慌，退休刑警被迫重返一线。当他逐渐逼近真相，却发现凶手的目标始终是自己。一场猫鼠之间的心理博弈，在雨夜的城市街头悄然展开。",
  },
  {
    id: "shiguang-xinjian",
    title: "时光信笺",
    poster: "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20young%20couple%20under%20warm%20autumn%20sunlight%20holding%20an%20old%20letter%2C%20soft%20amber%20and%20cream%20tones%2C%20minimal%20clean%20background%2C%20gentle%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-03&orientation=portrait",
    year: 2023,
    genres: ["爱情", "剧情"],
    region: "韩国",
    language: "韩语",
    duration: 112,
    director: "朴恩雅",
    cast: ["金秀贤", "宋慧乔", "边佑锡"],
    rating: 8.4,
    views: 7420000,
    heat: 8760,
    updatedAt: "2024-09-20",
    tagline: "有些话，迟到了十年才送到",
    synopsis:
      "一间濒临关闭的旧邮局，让两个相隔十年的灵魂通过信件相遇。当现实与回忆交错，他们必须决定：是留住过去，还是奔向彼此。",
  },
  {
    id: "baoxiao-yijiaqin",
    title: "爆笑一家亲",
    poster: "https://readdy.ai/api/search-image?query=Warm%20family%20comedy%20movie%20poster%2C%20cheerful%20family%20of%20four%20laughing%20together%20in%20a%20bright%20living%20room%2C%20warm%20orange%20and%20cream%20tones%2C%20minimal%20clean%20background%2C%20playful%20bright%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-04&orientation=portrait",
    year: 2024,
    genres: ["喜剧", "剧情"],
    region: "大陆",
    language: "国语",
    duration: 106,
    director: "冯小刚",
    cast: ["沈腾", "马丽", "黄渤"],
    rating: 8.1,
    views: 8940000,
    heat: 8450,
    updatedAt: "2024-09-18",
    tagline: "家有一老，如有一宝（也有点闹）",
    synopsis:
      "当三代人被迫挤进同一屋檐下，生活习惯的碰撞让家里天天上演喜剧大片。笑闹之后，一家人终于明白，所谓幸福不过是有人在等你回家吃饭。",
  },
  {
    id: "shenhai-micheng",
    title: "深海迷城",
    poster: "https://readdy.ai/api/search-image?query=Sci-fi%20mystery%20movie%20poster%2C%20diver%20descending%20toward%20a%20glowing%20underwater%20city%2C%20deep%20teal%20blue%20water%20with%20faint%20amber%20glow%2C%20minimal%20clean%20background%2C%20suspenseful%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-05&orientation=portrait",
    year: 2023,
    genres: ["科幻", "悬疑", "冒险"],
    region: "美国",
    language: "英语",
    duration: 130,
    director: "詹姆斯·卡隆",
    cast: ["杰森·莫玛", "佐伊·索尔达娜", "吴彦祖"],
    rating: 8.6,
    views: 8110000,
    heat: 8210,
    updatedAt: "2024-09-15",
    tagline: "海底之下，藏着人类不该知道的答案",
    synopsis:
      "一支国际科考队在马里亚纳海沟深处发现了一座不该存在的城市。随着探索深入，队员们意识到，最先浮出水面的不是真相，而是恐惧。",
  },
  {
    id: "jianying-jianghu",
    title: "剑影江湖",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20martial%20arts%20movie%20poster%2C%20lone%20swordsman%20standing%20on%20bamboo%20in%20misty%20mountains%2C%20deep%20ink%20blue%20with%20warm%20gold%20tones%2C%20minimal%20clean%20background%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-06&orientation=portrait",
    year: 2022,
    genres: ["动作", "武侠", "剧情"],
    region: "大陆",
    language: "国语",
    duration: 128,
    director: "张艺谋",
    cast: ["吴京", "章子怡", "易烊千玺"],
    rating: 8.3,
    views: 7650000,
    heat: 7890,
    updatedAt: "2024-09-10",
    tagline: "剑出鞘，恩怨了，江湖又开始",
    synopsis:
      "名震天下的剑客归隐山林，却因一封密函重入江湖。昔日的兄弟成了今日的敌人，当恩怨情仇在剑锋上交汇，他必须为心中的道义做出最终选择。",
  },
  {
    id: "miwu-shanzhuang",
    title: "迷雾山庄",
    poster: "https://readdy.ai/api/search-image?query=Gothic%20horror%20movie%20poster%2C%20creepy%20old%20mansion%20under%20thick%20night%20fog%2C%20single%20dim%20window%20light%2C%20dark%20desaturated%20tones%20with%20faint%20amber%20glow%2C%20minimal%20clean%20background%2C%20eerie%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-07&orientation=portrait",
    year: 2021,
    genres: ["恐怖", "悬疑"],
    region: "英国",
    language: "英语",
    duration: 98,
    director: "克里斯托弗·兰",
    cast: ["汤姆·哈迪", "艾玛·沃森", "拉尔夫·费因斯"],
    rating: 7.6,
    views: 5240000,
    heat: 6420,
    updatedAt: "2024-09-05",
    tagline: "进来容易，出去？试试看",
    synopsis:
      "五名陌生人受邀来到一座与世隔绝的山庄，却发现主人早已死去。随着大雾封锁山路，他们必须找出彼此之间真正的联系，否则没人能活着看到天亮。",
  },
  {
    id: "yunduan-zhilian",
    title: "云端之恋",
    poster: "https://readdy.ai/api/search-image?query=Modern%20romance%20movie%20poster%2C%20young%20woman%20and%20man%20silhouetted%20against%20soft%20pink%20sunset%20sky%2C%20warm%20peach%20and%20cream%20tones%2C%20minimal%20clean%20background%2C%20dreamy%20gentle%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-08&orientation=portrait",
    year: 2024,
    genres: ["爱情", "喜剧"],
    region: "大陆",
    language: "国语",
    duration: 104,
    director: "陈可辛",
    cast: ["周冬雨", "刘昊然", "张子枫"],
    rating: 8.0,
    views: 6890000,
    heat: 7680,
    updatedAt: "2024-10-02",
    tagline: "在高空相遇，在人间相爱",
    synopsis:
      "一名常年在云端飞行的空乘与一名恐高的建筑师意外相识。一个习惯了漂泊，一个渴望安稳，他们要用三万英尺的距离，丈量爱情真正的模样。",
  },
  {
    id: "jisu-kuangbiao",
    title: "极速狂飙",
    poster: "https://readdy.ai/api/search-image?query=High-octane%20racing%20action%20movie%20poster%2C%20supercar%20drifting%20on%20a%20night%20highway%20with%20light%20trails%2C%20deep%20navy%20with%20fiery%20orange%20accents%2C%20minimal%20clean%20background%2C%20dynamic%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-09&orientation=portrait",
    year: 2023,
    genres: ["动作", "犯罪"],
    region: "美国",
    language: "英语",
    duration: 118,
    director: "林诣彬",
    cast: ["范·迪塞尔", "杰森·斯坦森", "查理兹·塞隆"],
    rating: 8.2,
    views: 9230000,
    heat: 8840,
    updatedAt: "2024-09-30",
    tagline: "赢不了这场比赛，就输掉一切",
    synopsis:
      "退役车手被卷入一场地下赛车阴谋，为了救回被绑架的弟弟，他必须在一场没有规则的极速赛道上，用速度与智慧战胜所有对手。",
  },
  {
    id: "jiqi-jiyuan",
    title: "机器纪元",
    poster: "https://readdy.ai/api/search-image?query=Cyberpunk%20sci-fi%20movie%20poster%2C%20humanoid%20robot%20face%20with%20glowing%20eyes%20in%20a%20neon%20future%20city%2C%20deep%20blue%20with%20cyan%20and%20amber%20accents%2C%20minimal%20clean%20background%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-10&orientation=portrait",
    year: 2022,
    genres: ["科幻", "动作", "剧情"],
    region: "美国",
    language: "英语",
    duration: 142,
    director: "亚历克斯·加兰",
    cast: ["奥斯卡·伊萨克", "娜奥米·哈里斯", "多姆纳尔·格里森"],
    rating: 8.5,
    views: 6980000,
    heat: 7340,
    updatedAt: "2024-08-28",
    tagline: "当机器学会做梦，人类还剩什么",
    synopsis:
      "在高度智能化的未来都市，一台意外觉醒自我意识的服务型机器人，成为人类与AI之间战争的导火索。而唯一相信它善良的，是一位失去女儿的母亲。",
  },
  {
    id: "xiaonao-jianghu",
    title: "笑闹江湖",
    poster: "https://readdy.ai/api/search-image?query=Hong%20Kong%20comedy%20movie%20poster%2C%20goofy%20martial%20artist%20in%20colorful%20traditional%20robe%20striking%20a%20funny%20pose%2C%20warm%20orange%20and%20jade%20green%20tones%2C%20minimal%20clean%20background%2C%20bright%20playful%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-11&orientation=portrait",
    year: 2023,
    genres: ["喜剧", "动作"],
    region: "香港",
    language: "粤语",
    duration: 100,
    director: "周星驰",
    cast: ["周星驰", "吴君如", "黄一飞"],
    rating: 7.9,
    views: 6120000,
    heat: 7120,
    updatedAt: "2024-08-25",
    tagline: "笑一笑，武功也就练成了",
    synopsis:
      "一个连马步都扎不稳的餐馆伙夫，阴差阳错被当成绝世高手卷入武林纷争。靠着一点小聪明和一大堆好运气，他居然一路误打误撞地成了江湖传奇。",
  },
  {
    id: "wusheng-zhengci",
    title: "无声证词",
    poster: "https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20movie%20poster%2C%20witness%20behind%20rain-streaked%20glass%20window%2C%20cold%20blue%20tones%20with%20warm%20amber%20interior%20light%2C%20minimal%20clean%20background%2C%20tense%20moody%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-12&orientation=portrait",
    year: 2024,
    genres: ["悬疑", "犯罪", "剧情"],
    region: "韩国",
    language: "韩语",
    duration: 121,
    director: "奉俊昊",
    cast: ["宋康昊", "李政宰", "金泰梨"],
    rating: 8.9,
    views: 8560000,
    heat: 9120,
    updatedAt: "2024-10-01",
    tagline: "唯一目击者，什么也没说",
    synopsis:
      "一场看似普通的交通事故，牵扯出跨越十年的连环案件。当所有人都在说谎，唯一沉默的目击者，却掌握着最致命的真相。",
  },
  {
    id: "longhun-juexing",
    title: "龙魂觉醒",
    poster: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20action%20movie%20poster%2C%20warrior%20surrounded%20by%20golden%20dragon%20energy%2C%20deep%20blue%20night%20with%20fiery%20gold%20accents%2C%20minimal%20clean%20background%2C%20epic%20dramatic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-13&orientation=portrait",
    year: 2023,
    genres: ["奇幻", "动作", "冒险"],
    region: "大陆",
    language: "国语",
    duration: 133,
    director: "乌尔善",
    cast: ["费翔", "黄渤", "娜然"],
    rating: 8.2,
    views: 7890000,
    heat: 7980,
    updatedAt: "2024-09-22",
    tagline: "血脉觉醒之日，便是命运重写之时",
    synopsis:
      "被逐出宗门的少年体内封印着古老龙魂，当黑暗势力卷土重来，他必须直面血脉中的力量与诅咒，成为拯救苍生的最后希望。",
  },
  {
    id: "linju-mimi",
    title: "邻居的秘密",
    poster: "https://readdy.ai/api/search-image?query=Japanese%20light%20comedy%20drama%20movie%20poster%2C%20curious%20neighbor%20peeking%20through%20apartment%20door%20gap%2C%20soft%20warm%20cream%20and%20peach%20tones%2C%20minimal%20clean%20background%2C%20gentle%20bright%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-14&orientation=portrait",
    year: 2022,
    genres: ["喜剧", "爱情", "剧情"],
    region: "日本",
    language: "日语",
    duration: 108,
    director: "是枝裕和",
    cast: ["新垣结衣", "堺雅人", "広瀬铃"],
    rating: 8.1,
    views: 5860000,
    heat: 6780,
    updatedAt: "2024-08-20",
    tagline: "住你隔壁的人，可能最懂你",
    synopsis:
      "公寓里住着几个互不打扰的陌生人，直到一只走失的猫把他们的生活缠在一起。在窥探彼此秘密的过程中，他们意外找到了久违的温暖。",
  },
  {
    id: "mori-taosheng",
    title: "末日逃生",
    poster: "https://readdy.ai/api/search-image?query=Post-apocalyptic%20survival%20movie%20poster%2C%20lone%20survivor%20walking%20through%20a%20ruined%20city%20under%20orange%20dust%20sky%2C%20desaturated%20grey%20with%20fiery%20amber%20tones%2C%20minimal%20clean%20background%2C%20grim%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-15&orientation=portrait",
    year: 2021,
    genres: ["科幻", "动作", "冒险"],
    region: "美国",
    language: "英语",
    duration: 116,
    director: "罗兰·艾默里奇",
    cast: ["杰拉德·巴特勒", "朱莉娅·罗伯茨", "约翰·卡拉辛斯基"],
    rating: 7.7,
    views: 6340000,
    heat: 6890,
    updatedAt: "2024-08-15",
    tagline: "世界崩塌，唯一的出路是向前",
    synopsis:
      "一场全球性灾难让文明一夜归零，一位父亲带着女儿穿越废墟寻找安全的避难所。在资源耗尽与人心叵测之间，活下去本身就是一场战斗。",
  },
  {
    id: "shanhai-qiyuan",
    title: "山海奇缘",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20movie%20poster%2C%20mythical%20creature%20flying%20over%20ancient%20mountains%20with%20a%20young%20hero%2C%20warm%20jade%20green%20and%20gold%20tones%2C%20minimal%20clean%20background%2C%20magical%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-16&orientation=portrait",
    year: 2024,
    genres: ["动画", "奇幻", "冒险"],
    region: "大陆",
    language: "国语",
    duration: 96,
    director: "田晓鹏",
    cast: ["（配音）张杰", "（配音）刘校妤", "（配音）杨天翔"],
    rating: 8.8,
    views: 10230000,
    heat: 9540,
    updatedAt: "2024-10-03",
    tagline: "古老神话，全新冒险",
    synopsis:
      "少年为寻找失踪的父亲，踏入山海经中的奇异世界。他结识了会说话的灵兽与神秘的少女，在对抗上古凶兽的旅途中，逐渐明白勇气与担当的意义。",
  },
  {
    id: "xuese-liming",
    title: "血色黎明",
    poster: "https://readdy.ai/api/search-image?query=War%20drama%20movie%20poster%2C%20soldiers%20silhouetted%20against%20a%20smoky%20dawn%20battlefield%2C%20desaturated%20grey%20and%20amber%20sky%20tones%2C%20minimal%20clean%20background%2C%20somber%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-17&orientation=portrait",
    year: 2022,
    genres: ["战争", "剧情", "历史"],
    region: "英国",
    language: "英语",
    duration: 146,
    director: "萨姆·门德斯",
    cast: ["汤姆·哈迪", "本尼迪克特·康伯巴奇", "马克·里朗斯"],
    rating: 8.6,
    views: 5670000,
    heat: 7020,
    updatedAt: "2024-08-10",
    tagline: "他们守住的，是身后的整个黎明",
    synopsis:
      "一次决定战局走向的关键行动，两名士兵必须在炮火中穿越敌占区传递命令。如果失败，数千名战友将葬身于此；如果成功，他们也许活不到黎明。",
  },
  {
    id: "chengshi-zhiguang",
    title: "城市之光",
    poster: "https://readdy.ai/api/search-image?query=French%20art%20drama%20movie%20poster%2C%20lonely%20figure%20walking%20through%20a%20rainy%20Paris%20street%20at%20night%2C%20warm%20golden%20street%20lights%20against%20deep%20blue%2C%20minimal%20clean%20background%2C%20poetic%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-18&orientation=portrait",
    year: 2023,
    genres: ["剧情", "爱情"],
    region: "法国",
    language: "法语",
    duration: 110,
    director: "吕克·贝松",
    cast: ["玛丽昂·歌迪亚", "文森特·卡索", "蕾雅·赛杜"],
    rating: 8.3,
    views: 4120000,
    heat: 6120,
    updatedAt: "2024-08-05",
    tagline: "再暗的夜，也有一盏灯为你亮着",
    synopsis:
      "一位失意的街头艺人遇见了一名神秘的夜班护士。两个被城市遗忘的人，在无数个失眠的夜晚彼此照亮，共同寻找重新开始的勇气。",
  },
  {
    id: "huanjing-qibing",
    title: "幻境奇兵",
    poster: "https://readdy.ai/api/search-image?query=Action%20fantasy%20adventure%20movie%20poster%2C%20team%20of%20heroes%20facing%20a%20giant%20magical%20portal%2C%20deep%20teal%20with%20bright%20amber%20accents%2C%20minimal%20clean%20background%2C%20epic%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-19&orientation=portrait",
    year: 2024,
    genres: ["动作", "奇幻", "冒险"],
    region: "美国",
    language: "英语",
    duration: 127,
    director: "乔·罗素",
    cast: ["克里斯·埃文斯", "斯嘉丽·约翰逊", "道恩·强森"],
    rating: 8.0,
    views: 7150000,
    heat: 7820,
    updatedAt: "2024-09-26",
    tagline: "穿越幻境，只为守住现实",
    synopsis:
      "一支各怀绝技的小队被卷入异世界幻境，必须在三天内关闭失控的传送门。默契不足的他们，要在一次次生死考验中学会彼此信任。",
  },
  {
    id: "pengran-xindong",
    title: "怦然心动时",
    poster: "https://readdy.ai/api/search-image?query=Youth%20romance%20movie%20poster%2C%20high%20school%20couple%20under%20cherry%20blossoms%20in%20soft%20sunlight%2C%20pink%20and%20cream%20tones%20with%20warm%20amber%2C%20minimal%20clean%20background%2C%20tender%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-20&orientation=portrait",
    year: 2021,
    genres: ["爱情", "剧情"],
    region: "韩国",
    language: "韩语",
    duration: 102,
    director: "金高银",
    cast: ["朴宝剑", "金多美", "崔宇植"],
    rating: 8.2,
    views: 4980000,
    heat: 6580,
    updatedAt: "2024-07-28",
    tagline: "那年夏天，风是甜的",
    synopsis:
      "转学生与班里的优等生因为一本笔记本结缘。青涩的暗恋、笨拙的告白与毕业的离别，构成了一段永不褪色的青春记忆。",
  },
  {
    id: "youling-lieche",
    title: "幽灵列车",
    poster: "https://readdy.ai/api/search-image?query=Japanese%20horror%20movie%20poster%2C%20empty%20ghostly%20subway%20train%20with%20flickering%20lights%20in%20a%20dark%20tunnel%2C%20desaturated%20cold%20blue%20with%20faint%20amber%20glow%2C%20minimal%20clean%20background%2C%20eerie%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-21&orientation=portrait",
    year: 2023,
    genres: ["恐怖", "悬疑"],
    region: "日本",
    language: "日语",
    duration: 94,
    director: "清水崇",
    cast: ["苍井优", "染谷将太", "桥本爱"],
    rating: 7.4,
    views: 3860000,
    heat: 5980,
    updatedAt: "2024-07-20",
    tagline: "坐过这趟车的人，都没能下车",
    synopsis:
      "末班地铁误入一条早已废弃的隧道，乘客们发现列车正驶向一个不该存在的地方。当广播响起，他们才意识到，这趟旅程的终点叫做遗忘。",
  },
  {
    id: "yingxiong-guilai",
    title: "英雄归来",
    poster: "https://readdy.ai/api/search-image?query=Epic%20war%20hero%20movie%20poster%2C%20weathered%20soldier%20standing%20proudly%20on%20a%20hill%20at%20sunrise%2C%20deep%20navy%20with%20warm%20golden%20dawn%20accents%2C%20minimal%20clean%20background%2C%20heroic%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-22&orientation=portrait",
    year: 2024,
    genres: ["战争", "动作", "剧情"],
    region: "大陆",
    language: "国语",
    duration: 140,
    director: "管虎",
    cast: ["吴京", "张译", "易烊千玺"],
    rating: 8.5,
    views: 9670000,
    heat: 9210,
    updatedAt: "2024-10-04",
    tagline: "山河无恙，英雄有归期",
    synopsis:
      "一场惨烈的战役后，唯一幸存的战士带着战友的遗物踏上归乡之路。千里跋涉中，他要面对的不仅是 enemy，还有内心无法愈合的伤痕。",
  },
  {
    id: "shikong-lvren",
    title: "时空旅人",
    poster: "https://readdy.ai/api/search-image?query=Time-travel%20sci-fi%20movie%20poster%2C%20man%20looking%20into%20a%20swirling%20clock%20portal%20of%20light%2C%20deep%20blue%20with%20warm%20amber%20glow%20accents%2C%20minimal%20clean%20background%2C%20mysterious%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-23&orientation=portrait",
    year: 2020,
    genres: ["科幻", "爱情", "剧情"],
    region: "美国",
    language: "英语",
    duration: 122,
    director: "丹尼斯·维伦纽瓦",
    cast: ["瑞恩·高斯林", "艾米·亚当斯", "杰瑞米·雷纳"],
    rating: 8.7,
    views: 5890000,
    heat: 6940,
    updatedAt: "2024-07-15",
    tagline: "如果能回到过去，你还会选择遇见我吗",
    synopsis:
      "物理学家意外发明了时光装置，却发现每一次穿越都会改变深爱的妻子的命运。为了守护她，他必须在时间的洪流中做出最艰难的抉择。",
  },
  {
    id: "xiaozhen-yiyun",
    title: "小镇疑云",
    poster: "https://readdy.ai/api/search-image?query=British%20mystery%20drama%20movie%20poster%2C%20quiet%20foggy%20small%20town%20street%20with%20a%20distant%20figure%2C%20desaturated%20grey%20blue%20with%20faint%20amber%20window%20light%2C%20minimal%20clean%20background%2C%20tense%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-24&orientation=portrait",
    year: 2022,
    genres: ["悬疑", "剧情", "犯罪"],
    region: "英国",
    language: "英语",
    duration: 114,
    director: "埃德加·赖特",
    cast: ["奥利维娅·科尔曼", "大卫·田纳特", "裴淳华"],
    rating: 8.4,
    views: 3960000,
    heat: 6260,
    updatedAt: "2024-07-10",
    tagline: "平静的小镇，藏不住的血迹",
    synopsis:
      "一名少女在小镇失踪，警探在调查中揭开居民们精心维护的平静表象。越接近真相，她越发现这里每个人都藏着不愿示人的秘密。",
  },
  {
    id: "fengkuang-paidao",
    title: "疯狂派对",
    poster: "https://readdy.ai/api/search-image?query=Fun%20party%20comedy%20movie%20poster%2C%20joyful%20group%20of%20friends%20celebrating%20with%20confetti%20and%20balloons%2C%20vibrant%20orange%20and%20cream%20tones%2C%20minimal%20clean%20background%2C%20bright%20festive%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-25&orientation=portrait",
    year: 2024,
    genres: ["喜剧", "剧情"],
    region: "美国",
    language: "英语",
    duration: 99,
    director: "托德·菲利普斯",
    cast: ["布莱德利·库珀", "詹妮弗·劳伦斯", "乔纳·希尔"],
    rating: 7.8,
    views: 5420000,
    heat: 7020,
    updatedAt: "2024-09-12",
    tagline: "一场派对，炸出所有人的秘密",
    synopsis:
      "为了庆祝升职，一群老友举办了十年来的第一次聚会。然而随着酒精上头，隐藏的误会、旧怨与暗恋接连爆发，这场派对彻底失控。",
  },
  {
    id: "huajian-ling",
    title: "花间令",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20period%20romance%20drama%20poster%2C%20elegant%20woman%20in%20flowing%20traditional%20dress%20among%20falling%20petals%2C%20warm%20peach%20blush%20and%20jade%20tones%2C%20minimal%20clean%20background%2C%20soft%20cinematic%20lighting%2C%20high%20detail%20professional%20promotional%20artwork&width=400&height=600&seq=movie-poster-26&orientation=portrait",
    year: 2023,
    genres: ["爱情", "剧情", "古装"],
    region: "大陆",
    language: "国语",
    duration: 118,
    director: "李国立",
    cast: ["赵丽颖", "王一博", "杨紫"],
    rating: 8.3,
    views: 7310000,
    heat: 8120,
    updatedAt: "2024-09-08",
    tagline: "一纸花令，牵动两世情缘",
    synopsis:
      "掌管花令的宫中女官与冷面将军因一场误会结缘。在权谋与阴谋交织的深宫里，他们用一次次试探与守护，写下一段荡气回肠的情缘。",
  },
];